var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"idd-minutes-widget"},[_c('h6',{staticClass:"idd-minutes"},[_vm._v(_vm._s(_vm.$t('navigation.iddYearMinutes', { year: _setup.currentYear }))+":")]),_c('h5',[_vm._v(_vm._s(_setup.iddMinutesCounter)+"min")])])
}
var staticRenderFns = []

export { render, staticRenderFns }